import React from 'react';
import { Routes, useLocation } from 'react-router-dom';

import ContainerRoute from './ContainerRoute'
// import DashboardPage from '../pages/Dashboard/DashboardPage';
import UsersRoutes from './UsersRoutes';
import MypageRoutes from './MypageRoutes';

import { findBreadcrumbs } from '@data/nav'
import { translateText } from '@/i18n/translate'

import NotFound from '../pages/NotFound';

const AppRoutes = () => {
  const location = useLocation()
  const port = window.location.port;

  React.useEffect(() => {
    const crumbs = findBreadcrumbs(location.pathname) || []

    if (crumbs.length === 0) {
      document.title = 'OpenVLab'
      return
    }

    const title = crumbs
      .map(c => translateText(c.label))
      .reverse()
      .join(' | ')

    document.title = `${title} | OpenVLab`
  }, [location.pathname])

  // 퍼블 화면은 개발 서버(4000)에서만. 운영 빌드에는 라우트를 넣지 않는다.
  if (process.env.NODE_ENV !== 'production' && port === '4000') {
    const PblshRoutes = require('./PublishRoutes').default;
    return (
      <Routes>
        {PblshRoutes()}
      </Routes>
    );
  }

  return (
    <Routes>
      {UsersRoutes()}
      {MypageRoutes()}
      {ContainerRoute('/*', <NotFound />, { hideHeader: true, hasSidebar: false })}
    </Routes>
  );
};

export default AppRoutes;